'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import Pagination from 'Components/Pagination';
import CoworkingSpace from 'Components/Front/CoworkingSpace';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import isInViewport from 'Functions/isInViewport';
import scrollToNode from 'Functions/scrollToNode';
import truncate from 'Functions/truncate';
import bemit from 'Functions/bemit';
import { getSessionStorage } from 'Functions/SessionStorage/frontPage';
import { getMinMaxSeats, num, isTrue } from 'Shared/utilities';
import { URL, action } from 'Shared/Routes';
const {
  app,
  qwest,
  moment
} = window;
export default class SpacesBlock extends Component {
  state = function () {
    const props = this.props;
    const state = {
      data: [],
      data_count: this.props['items-per-page'] || 6,
      page: 0,
      rows_per_page: this.props['items-per-page'] || 6,
      order: this.props['order'] || 'asc',
      order_by: this.props['order-by'] || 'name',
      skip: 0,
      limit: 0,
      title: 'Nos différents espaces de coworking',
      loading: true
    };
    const session_storage = props['use-session'] && props.pathname ? getSessionStorage({
      pathname: props.pathname
    }) : {};
    state.type = session_storage.type ? session_storage.type : isTrue(props['use-widget']) ? window.localStorage.getItem('widget-space-type') : props.type;
    if (!state.type) state.type = 'all';
    state.date = session_storage.date ? session_storage.date : isTrue(props['use-widget']) ? window.localStorage.getItem('widget-date') : props.date;
    if (!state.date) state.date = moment().format('YYYY-MM-DD');
    return state;
  }.bind(this)();
  list_ref = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetch({});
    app.push({
      event: 'ScrollToSpaceAvailability',
      cb: component.handleScrollRequest
    });
    app.push({
      event: 'UpdatedSideWidget',
      cb: component.handleSideWidgetChange
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'ScrollToSpaceAvailability',
      cb: component.handleScrollRequest
    });
    app.delete({
      event: 'UpdatedSideWidget',
      cb: component.handleSideWidgetChange
    });
  }
  componentDidUpdate() {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.scroll_requested === true) {
      component.scroll_requested = false;
      window.setTimeout(function () {
        component.handleScrollRequest({});
      }, 120);
    }
  }
  handleSideWidgetChange = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const new_type = window.localStorage.getItem('widget-space-type') || '';
    if (state.type === new_type) {
      if (data.scrollToAvailability === true) {
        component.handleScrollRequest({});
      }
      return;
    }
    component.fetch({
      type: new_type,
      scroll: data.scrollToAvailability === true
    });
  };
  handleScrollRequest = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const list = document.getElementById('spaces-block-list');
    if (isInViewport(list)) return; // liste déjà visible

    const tabs = document.querySelector('.js-establishment-tabs');
    component.scroll_requested = false;
    const tabs_height = tabs ? tabs.getBoundingClientRect().height : 54;
    const target = document.getElementById('info');
    if (!target || !target.scrollIntoView) return;
    scrollToNode({
      node: target,
      offset: tabs_height || 54,
      force: true
    });
  };
  fetch = ({
    type,
    page,
    scroll = false
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const current_page = typeof page === 'undefined' ? state.page : page;
    const session_storage = props['use-session'] && props.pathname ? getSessionStorage({
      pathname: props.pathname
    }) : {};
    const used_type = typeof type !== 'undefined' ? type : session_storage.type ? session_storage.type : state.type;
    component.setState({
      loading: true,
      type: used_type
    });
    qwest.post(action('getAllFrontSpaces'), {
      limit: state.rows_per_page,
      skip: state.rows_per_page * current_page,
      type: used_type,
      etablishment_id: props['etablishment-id'],
      with_spaces_max_bookable: props['with_spaces_max_bookable']
    }).then(function (xhr, response) {
      if (scroll === true) {
        component.scroll_requested = true;
      }
      component.setState({
        loading: false,
        data_count: response.count || 0,
        data: (response.data || []).map(function (data) {
          data.description = truncate(data.description, 160);
          data.min_max_seats = getMinMaxSeats(data);
          return data;
        }),
        title: state.title
      });
      if (typeof props.onFetch === 'function') {
        const onfetch_data = {
          spaces: response.data,
          count: response.count || 0
        };
        if (props['with_spaces_max_bookable']) {
          onfetch_data.spaces_max_bookable = num(response.spaces_max_bookable, 0);
        }
        props.onFetch(onfetch_data);
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handlePageChange = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      page: page
    });
    component.fetch({
      page: page
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const modifiers = ['space'].concat(props.bemit || []);
    const spaces = (state.data || []).map(function (data) {
      const output = /*#__PURE__*/React.createElement(CoworkingSpace, _extends({}, data, {
        bemit: modifiers,
        key: data.id,
        "layout-type": props['layout-type'],
        availability: true,
        "init-from-props": props['use-session'],
        date: state.date
      }));
      return output;
    });
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white'],
      text: "Chargement..."
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("section", {
      className: bemit('o-spaces-block', modifiers),
      id: "spaces-block-list"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__top"
    }, props.title !== false ? /*#__PURE__*/React.createElement("header", {
      className: "o-spaces-block__header"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "c-title"
    }, state.title)) : undefined, props['with-home-btn'] ? /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__link"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['blue', 'front']),
      component: Link,
      href: URL('HomePage')
    }, "Retour \xE0 l'accueil")) : undefined), /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__list",
      ref: component.list_ref
    }, spaces?.length < 1 ? /*#__PURE__*/React.createElement("p", null, "Ce myWO ne poss\xE8de pas ce type d'espace") : undefined, spaces, /* Prevent grow on last items */
    props['layout-type'] !== 'side' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    })) : undefined), props.pagination !== false ? /*#__PURE__*/React.createElement(Pagination, {
      current: state.page,
      total: state.data_count,
      "items-per-page": state.rows_per_page,
      onChange: component.handlePageChange,
      bemit: ['spaces-block', 'front'],
      "hide-count": true
    }) : undefined, loader);
    return output;
  }
}
